import {  
  GENERAL_REQUEST_LOADING,
  PARTNER_SET_LOADING,

  PARTNER_LOGIN_SUCCESS,
  TOOLS_ACCESS_PARTNER_ACCOUNT_SUCCESS,

  PARTNER_UPDATE_ASSISTANT_FAIL,
  PARTNER_UPDATE_ASSISTANT_SUCCESS,

  PARTNER_UPDATE_WEB_FAIL,
  PARTNER_UPDATE_WEB_SUCCESS,

  PARTNER_GET_AGENT_SUCCESS,
  PARTNER_GET_AGENT_FAIL,

  PARTNER_GET_CLIENTDETAILS,
  PARTNER_GET_CLIENTDETAILS_SUCCESS,
  PARTNER_GET_CLIENTDETAILS_FAIL,
  PARTNER_UPDATE_DATA,
  AUTH_PARTNER_FAIL,
  PARTNER_GET_BANKING_SUCCESS,
  PARTNER_SET_BANKING_SUCCESS,
  PARTNER_BANKING_IMAGE_ADD,
  PARTNER_BANKING_IMAGE_ADD_SUCCESS,
  PARTNER_BANKING_IMAGE_ADD_FAILED,
  PARTNER_BANKING_IMAGE_RESET,
  LOGOUT } from '../actions/types';

export const INITIAL_STATE = {
    partner: {},
    requestedPartner: {},
    personalInput: { agentname: '', agentid: '', company: '', street1:'', street2: '', postalcode: '', city: '', province: '', phone: '', ext: '', cell: '', fax: '', email: '', webname: '', webtele: '', webintro: ''},
    personalBanking: '',
    chequeImage: '',
    error: false,
    errors: { },
    message: '',
    loading: false,
  };


const reducer =  (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case PARTNER_SET_LOADING:
        return {
          ...state,
          error: false,
          errors: {},
          loading: true
        };
      case PARTNER_UPDATE_DATA:
          return (action.datagroup !== '')?
          { ...state, [action.datagroup]: {...state[action.datagroup], [action.dataname]: action.datavalue }, error: false, errors: {}, loading: false }
          :
          { ...state, [action.dataname]: action.datavalue, error: false, loading: false };
      case PARTNER_GET_CLIENTDETAILS:
        return {...state, loading: true }
      case PARTNER_GET_CLIENTDETAILS_SUCCESS:
        return {...state, partner: { ...state.partner, clientData: action.clientData}, error: false, errors: {}, message: action.message, loading: false }
      case PARTNER_GET_CLIENTDETAILS_FAIL:
        return {...state, partner: INITIAL_STATE.partner, error: true, errors: action.errors, loading: false }
      case PARTNER_BANKING_IMAGE_ADD:
        return {
          ...state,
          error: false,
          errors: {},
          loading: true
        };
      case PARTNER_BANKING_IMAGE_ADD_SUCCESS:
        return {
          ...state,
          chequeImage: action.data,
          error: false,
          errors: {},
          loading: false
        };
      case PARTNER_BANKING_IMAGE_ADD_FAILED:
        return { ...state, error: true, errors: action.errors, loading: false };
      case PARTNER_BANKING_IMAGE_RESET:
        return {
          ...state,
          chequeImage: INITIAL_STATE.chequeImage,
          error: false,
          errors: {},
          loading: false
        };
      case PARTNER_GET_BANKING_SUCCESS:
        return { ...state,
          partner: { ...state.partner},
          error: false,
          personalBanking: action.data.personalBanking,
          chequeImage: INITIAL_STATE.chequeImage,
          errors: {},
          loading: false,
          success: true,
          message: action.data.message
        };
      case PARTNER_SET_BANKING_SUCCESS:
        return { ...state,
          partner: { ...state.partner},
          error: false,
          personalBanking: action.data.personalBanking,
          chequeImage: INITIAL_STATE.chequeImage,
          errors: {},
          loading: false,
          success: true,
          message: action.data.message
        };
      case PARTNER_UPDATE_ASSISTANT_FAIL:
        return {...state, error: true, errors: action.errors, loading: false};
      case PARTNER_UPDATE_ASSISTANT_SUCCESS:
        return {...state, error: false, errors: {}, loading: false};
      case PARTNER_GET_AGENT_SUCCESS:
        return {...state, requestedPartner: {...action.data.agentdata} };
      case PARTNER_GET_AGENT_FAIL:
        return {...state, error: false, errors: {}, loading: false};
      case PARTNER_UPDATE_WEB_FAIL:
        return {...state, error: true, errors: action.errors, loading: false};
      case PARTNER_UPDATE_WEB_SUCCESS:
        return {...state, error: false, errors: {}, loading: false};
      case AUTH_PARTNER_FAIL:
        return {...state, error: true, errors: action.errors, loading: false};
      case GENERAL_REQUEST_LOADING:
        return { ...state, error: false, errors: {}};

      case PARTNER_LOGIN_SUCCESS:
        return INITIAL_STATE;
      case TOOLS_ACCESS_PARTNER_ACCOUNT_SUCCESS:
        return INITIAL_STATE;

      case LOGOUT:
        return INITIAL_STATE;
      default:
        return state;
    }
};


export default reducer;
